import { NegotiationOption, NegotiationOptionAlternativeType, Normative026, OutDebt } from '../generated/graphql';
import { getNegBooleans } from './getNegBooleans';

export const getExtraN26Suffix = (outDebt?: OutDebt, option?: NegotiationOption) => {
  if (!outDebt) return '';
  const { extra } = outDebt;
  const { normative026: rawN26 } = extra || {};
  const { isBbva, isRefinance, isScotiabank, isTranqui } = getNegBooleans(outDebt, option);

  // For BBVA, take into account the alternative type istead of this disgusting spaghetti
  // !!! had to repeat this logic because I don't know if it's properly implementende in accordance
  // with the other getNormative026ContentKey, and I don't want to risk breaking something
  const overwriteToRestructureBbva = isBbva && isTranqui && isRefinance
    && option?.alternatives[0].type === NegotiationOptionAlternativeType.Restructuring;

  const n26 = overwriteToRestructureBbva ? Normative026.Restructuring : rawN26;

  const bbvaRefRestructuring = isBbva && isRefinance && n26 === Normative026.Restructuring;
  const scotiaRef = isScotiabank && isRefinance && n26 !== Normative026.Refinance;
  if (bbvaRefRestructuring || scotiaRef) return `_${n26}`;
  return '';
};
